module.exports = __webpack_public_path__ + "img/retro_tv.8ad5ea27.svg";